import PropTypes from "prop-types";
import classNames from "classnames";
import "./DateIcon.css";

export function DateIcon({ active = true, dayOfMonth, size = "medium" }) {
  return (
    <div
      className={classNames({
        "date-icon": true,
        "date-icon--inactive": !active,
        "date-icon--small": size === "small",
      })}
    >
      <div className="date-icon__header" />
      <div className="date-icon__date">{dayOfMonth}</div>
    </div>
  );
}

DateIcon.propTypes = {
  active: PropTypes.bool,
  dayOfMonth: PropTypes.number,
  size: PropTypes.oneOf(["small", "medium"]),
};
